import fetch from 'node-fetch';

global.fetch = fetch;
